import { useMemo } from "react";

type Adapter<RawType, AdaptedType> = (payload: RawType) => AdaptedType;

export default function useAdaptedData<RawType, AdaptedType>({
  data,
  adapter,
}: {
  data?: RawType;
  adapter: Adapter<RawType, AdaptedType>;
}) {
  return useMemo(() => {
    if (!data) {
      return undefined;
    }
    return adapter(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
}
